import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20streaming%20platform%20background%20with%20flowing%20gradient%20waves%20in%20warm%20coral%20and%20deep%20charcoal%20tones%2C%20soft%20geometric%20patterns%2C%20modern%20technology%20aesthetic%2C%20minimal%20and%20elegant%20composition%2C%20dark%20atmospheric%20vibe&width=1920&height=1080&seq=hero-bg-4688&orientation=landscape"
          alt="4688.tv 在线视频平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
            精彩内容{' '}
            <span className="text-primary-400">一触即达</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-xl mx-auto">
            海量高清视频资源，涵盖电影、电视剧、综艺、动漫、纪录片，
            随时随地畅享流畅播放体验，开启您的视听新世界
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="#"
              className="px-8 py-3.5 bg-primary-500 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap transform hover:scale-105"
            >
              免费注册 · 7天会员体验
            </Link>
            <Link
              to="/category/dianying"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white text-sm md:text-base font-medium rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap border border-white/20"
            >
              浏览内容
              <i className="ri-arrow-right-line ml-2" />
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 md:gap-12 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">50,000+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">海量内容</div>
            </div>
            <div className="w-px h-10 bg-white/20" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">8,000万</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">活跃用户</div>
            </div>
            <div className="w-px h-10 bg-white/20" />
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">4K HDR</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">超清画质</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl" />
      </div>
    </section>
  );
}